import React from 'react';

import ButtonBlock from 'blocks/ButtonBlock';
import config from 'config';
import { FormattedMessage } from 'react-intl';

export const openWhatsapp = (text?: string, sales?: boolean) => {
  const message = text ? text : encodeURIComponent(config.whatsappMessage);
  window.open(
    'https://api.whatsapp.com/send?phone=' +
      encodeURIComponent(sales ? config.whatsappSalesNumber : config.whatsappSupport) +
      '&text=' +
      message
  );
};

export default ({ messageId, text, sales }: { messageId?: string; text?: string, sales?: boolean }) => (
  <ButtonBlock background="WHATSAPP" onClick={() => openWhatsapp(text, sales)}>
    <FormattedMessage id={messageId || 'Contact us on WhatsApp'} />
  </ButtonBlock>
);
